import Vue from 'vue'
export const dialogDrag = Vue.directive('dialogDrag', {
  bind(el, binding, vnode, oldVnode) {
    let dialogHeaderEl = el.querySelector('.el-dialog__header');
    // if(!dialogHeaderEl){
    //   dialogHeaderEl=el.querySelector('.'+binding.value.headerClass)
    // }
    if (binding.value && binding.value.headerClass) {
      for (let i = 0; i < el.children.length; i++) {
        if (el.children[i].className.indexOf(binding.value.headerClass) >= 0) {
          dialogHeaderEl = el.children[i]
          break
        }
      }
    }
    let dragDom = el.querySelector('.el-dialog')  //elementUI的dialog
    if(binding.value && binding.value.type && binding.value.type=='custom'){  //自己写的拖拽的盒子
      dragDom = el
    }
    dialogHeaderEl.style.cursor = 'move'
    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    if(!dragDom){
      return
    }
    const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null)
    dialogHeaderEl.onmousedown = (e) => {
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - dialogHeaderEl.offsetLeft
      const disY = e.clientY - dialogHeaderEl.offsetTop

      // 获取到的值带px 正则匹配替换
      let styL, styT

      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      if (sty.left.includes('%')) {
        styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100)
        styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100)
      } else {
        styL = +sty.left.replace(/\px/g, '')
        styT = +sty.top.replace(/\px/g, '')
      }

      document.onmousemove = function (e) {
        // 通过事件委托，计算移动的距离
        const l = e.clientX - disX
        const t = e.clientY - disY

        // 移动当前元素
        dragDom.style.left = `${l + styL}px`
        dragDom.style.top = `${t + styT}px`

        // 将此时的位置传出去
        // binding.value({x:e.pageX,y:e.pageY})
      }

      document.onmouseup = function (e) {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
});
export const eleDrag = Vue.directive('eleDrag', {
  bind(el, binding, vnode, oldVnode) {
    let dialogHeaderEl = el.querySelector('.el-dialog__header');
    if (binding.value && binding.value.headerClass) {
      for (let i = 0; i < el.children.length; i++) {
        if (el.children[i].className.indexOf(binding.value.headerClass) >= 0) {
          dialogHeaderEl = el.children[i]
          break
        }
      }
    }
    const dragDom = el;
    dialogHeaderEl.style.cursor = 'move';
    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);
    dialogHeaderEl.onmousedown = (e) => {
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - getPoint(dialogHeaderEl, 'offsetLeft');
      const disY = e.clientY - getPoint(dialogHeaderEl, 'offsetTop');
      // 获取到的值带px 正则匹配替换
      let styL, styT;
      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      if (sty.left.includes('%')) {
        styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100);
        styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100);
      } else {
        styL = +sty.left.replace(/\px/g, '');
        styT = +sty.top.replace(/\px/g, '');
      };
      document.onmousemove = function (e) {
        // 通过事件委托，计算移动的距离 
        const l = e.clientX - disX;
        const t = e.clientY - disY;
        // 移动当前元素  
        dragDom.style.left = `${l}px`;
        dragDom.style.top = `${t}px`;
        //将此时的位置传出去
        //binding.value({x:e.pageX,y:e.pageY})
      };
      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    }
  }
})
function getPoint(obj, val) { //获取某元素以浏览器左上角为原点的坐标
  var t = obj[val]; //获取该元素对应父容器的上边距
  // var l = obj.offsetLeft; //对应父容器的上边距
  //判断是否有父容器，如果存在则累加其边距
  while (obj = obj.offsetParent) {//等效 obj = obj.offsetParent;while (obj != undefined)
    t += obj[val]; //叠加父容器的上边距
    // l += obj.offsetLeft; //叠加父容器的左边距
  }
  return t
}


// WEBPACK FOOTER //
// ./src/libs/utils/directive.js